/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkillSuggestionResponse
 */
export interface SkillSuggestionResponse {
    /**
     * 
     * @type {string}
     * @memberof SkillSuggestionResponse
     */
    tagId?: string;
    /**
     * 
     * @type {string}
     * @memberof SkillSuggestionResponse
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof SkillSuggestionResponse
     */
    occurrences: number;
    /**
     * 
     * @type {string}
     * @memberof SkillSuggestionResponse
     */
    universe?: string;
}

/**
 * Check if a given object implements the SkillSuggestionResponse interface.
 */
export function instanceOfSkillSuggestionResponse(value: object): value is SkillSuggestionResponse {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('occurrences' in value) || value['occurrences'] === undefined) return false;
    return true;
}

export function SkillSuggestionResponseFromJSON(json: any): SkillSuggestionResponse {
    return SkillSuggestionResponseFromJSONTyped(json, false);
}

export function SkillSuggestionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillSuggestionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tagId': json['tagId'] == null ? undefined : json['tagId'],
        'label': json['label'],
        'occurrences': json['occurrences'],
        'universe': json['universe'] == null ? undefined : json['universe'],
    };
}

export function SkillSuggestionResponseToJSON(value?: SkillSuggestionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tagId': value['tagId'],
        'label': value['label'],
        'occurrences': value['occurrences'],
        'universe': value['universe'],
    };
}

